import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import welfareService from '../utils/welfareService';
import { snackbar } from '../utils/showMessage';

import { ArrowBack, Article, Campaign, AccessTime, Visibility } from '@mui/icons-material';
import { Modal } from '@mui/material';


const BASE_URL = process.env.REACT_APP_API_BASE_URL;


const WelfareCategories = () => {
    const [loading, setLoading] = useState(true);

    const [categories, setCategories] = useState([]);
    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            setLoading(true);
            const categoriesData = await welfareService.getCategories();
            setCategories(categoriesData);

        } catch (error) {
            console.error('Error loading welfare data:', error);
            snackbar('خطا در بارگذاری اطلاعات');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

    }, []);
    // پاپاپ زیرکتگوری و شمارنده
    const [subModalOpen, setSubModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [subCategories, setSubCategories] = useState([]);
    const fetchSubItemsCount = async (category, subCats) => {
        if (!category || !Array.isArray(subCats)) return subCats;
        const updated = await Promise.all(subCats.map(async (sub) => {
            try {
                const count = await welfareService.getSubCategoryItemsCount(category._id, sub.id);
                return { ...sub, itemsCount: typeof count === 'number' ? count : 0 };
            } catch {
                return { ...sub, itemsCount: 0 };
            }
        }));
        // آیتم همه موارد
        let allCount = 0;
        try {
            const res = await welfareService.getSubCategoryItemsCount(category._id, undefined);
            allCount = typeof res === 'number' ? res : 0;
        } catch (e) {
            allCount = 0;
        }
        const allItem = {
            id: 'all',
            title: 'همه موارد',
            image: category.image,
            description: '',
            itemsCount: allCount,
            isAll: true,
        };
        return [...updated, allItem];
    };

    const NewCard = (item) => {
        const hasSub = Array.isArray(item.subCategories) && item.subCategories.length > 0;
        return (
            <div
                className="card mb-3 text-decoration-none"
                style={{ cursor: hasSub ? 'pointer' : 'auto' }}
                onClick={async () => {
                    if (hasSub) {
                        setSelectedCategory(item);
                        setSubModalOpen(true);
                        const subCatsWithCount = await fetchSubItemsCount(item, item.subCategories);
                        setSubCategories(subCatsWithCount);
                    }
                }}
            >
                <div className="card-body">
                    <div className="row">
                        {item.image && (
                            <div className="col-4 col-md-3">
                                <img
                                    src={`${BASE_URL}/uploads/documents/${item.image}` || '/assets/img/default-service.png'}
                                    alt={item.title}
                                    className="w-100 rounded-15"
                                    style={{ height: '100px', objectFit: 'cover' }}
                                />
                            </div>
                        )}
                        <div className={item.image ? 'col-8 col-md-9' : 'col-12'}>
                            <h6 className="mb-2">{item.title}</h6>
                            {item.description && (
                                <p className="text-muted mb-2 text-justify" style={{ fontSize: '0.9rem' }}>
                                    {item.description.length > 100
                                        ? item.description.substring(0, 100) + '...'
                                        : item.description}
                                </p>
                            )}
                            <div className="d-flex justify-content-end align-items-bottom">
                                <small className="text-muted">
                                    {typeof item.itemsCount === 'number' ? item.itemsCount : 0} مورد
                                </small>
                            </div>
                        </div>
                    </div>
                    {hasSub && (
                        <div className="mt-3">
                            <div className="d-flex flex-wrap gap-2">
                                {item.subCategories.map((sub, index) => (
                                    <Link
                                        key={sub.id || index}
                                        to={`/welfare/${item._id}?sub=${sub.id}`}
                                        className="text-decoration-none d-flex flex-column align-items-center"
                                        style={{ minWidth: '90px' }}
                                    >
                                        {sub.image ? (
                                            <img
                                                src={sub.image === '/assets/img/default-service.png' ? sub.image : `${BASE_URL}/uploads/documents/${sub.image}`}
                                                alt={sub.title}
                                                className="rounded-circle"
                                                style={{ width: '48px', height: '48px', objectFit: 'cover' }}
                                            />
                                        ) : (
                                            <div
                                                className="rounded-circle bg-secondary d-flex align-items-center justify-content-center"
                                                style={{ width: '48px', height: '48px' }}
                                            >
                                                <span className="text-white" style={{ fontSize: '14px' }}>?</span>
                                            </div>
                                        )}
                                        <small className="text-center mt-1" style={{ fontSize: '0.7rem', lineHeight: '1' }}>
                                            {sub.title.length > 10 ? sub.title.substring(0, 10) + '...' : sub.title}
                                        </small>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };
    return (
        <div className="main-container container " style={{
            paddingTop: 10
        }}>

            {categories.map((category) => (
                <React.Fragment key={category._id}>
                    {NewCard(category)}
                </React.Fragment>
            ))}
            {/* Modal for subcategories */}
            <Modal open={subModalOpen} onClose={() => setSubModalOpen(false)}>
                <div style={{
                    position: "relative",
                    background: '#fff',
                    padding: 24,
                    borderRadius: 18,
                    maxWidth: '90vw',
                    width: '90vw',
                    height: '90vh',
                    margin: '5vh auto',
                    outline: 'none',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                    <h6 className="mb-3">{selectedCategory?.title}</h6>
                    <button
                        onClick={() => setSubModalOpen(false)}
                        style={{
                            position: 'absolute',
                            top: 12,
                            left: 12,
                            background: 'transparent',
                            border: 'none',
                            fontSize: 28,
                            cursor: 'pointer',
                            zIndex: 10,
                            color: '#888',
                        }}
                        aria-label="بستن"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="row w-100 mb-3">
                        <div className="col-12">
                            <div className="row gx-2 gy-3">
                                {subCategories.map(sub =>
                                    <Link
                                        to={sub.isAll ? `/welfare/${selectedCategory?._id}` : `/welfare/${selectedCategory?._id}?sub=${sub.id}`}
                                        className="card mb-3 text-decoration-none"
                                        key={sub.id}
                                    >
                                        <div className="card-body">
                                            <div className="row">
                                                {sub.image && (
                                                    <div className="col-4 col-md-3">
                                                        <img
                                                            src={sub.image === '/assets/img/default-service.png' ? sub.image : `${BASE_URL}/uploads/documents/${sub.image}`}
                                                            alt={sub.title}
                                                            className="w-100 rounded-15"
                                                            style={{ height: '100px', objectFit: 'cover' }}
                                                        />
                                                    </div>
                                                )}
                                                <div className={sub.image ? 'col-8 col-md-9' : 'col-12'}>
                                                    <h6 className="mb-2">{sub.title}</h6>
                                                    {sub.description && (
                                                        <p className="text-muted mb-2 text-justify" style={{ fontSize: '0.9rem' }}>
                                                            {sub.description.length > 100
                                                                ? sub.description.substring(0, 100) + '...'
                                                                : sub.description}
                                                        </p>
                                                    )}
                                                    <div className="d-flex justify-content-end align-items-bottom">
                                                        <small className="text-muted">
                                                            {typeof sub.itemsCount === 'number' ? sub.itemsCount : 0} مورد
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};



export default WelfareCategories;
